import React from 'react';

const PATHS = {
  none: 'm7 15 5 5 5-5M7 9l5-5 5 5',
  asc: 'm18 15-6-6-6 6',
  desc: 'm6 9 6 6 6-6',
};

const SortIcon = ({ active = false, direction = 'asc', fill = 'currentColor', width = '14', height = '14' }) => {
  const d = active ? (direction === 'asc' ? PATHS.asc : PATHS.desc) : PATHS.none;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d={d} stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SortIcon;
